import { type ApiEndpointName } from '../routing/apiRouting';

// Auth-header provider for the dashboard GraphQL client. Emits a standard
// `Authorization: Bearer` header when a token is available — same contract
// CoreAuthGuard expects (see server/src/common/guards/core-auth.guard.ts).
export type AuthHeaderContext = {
  endpoint: ApiEndpointName;
  operationType: string;
};

export type AuthHeadersOptions = {
  // Returns the current access token (Core JWT), or undefined when unauthenticated.
  // Read lazily per request so the latest token from the store is always used.
  getAccessToken?: (context: AuthHeaderContext) => string | undefined;
  additionalHeaders?: Record<string, string>;
};

export const createAuthHeadersProvider = (options?: AuthHeadersOptions) => {
  return ({ endpoint, operationType }: AuthHeaderContext): HeadersInit => {
    const accessToken = options?.getAccessToken?.({ endpoint, operationType });

    return {
      ...options?.additionalHeaders,
      ...(accessToken ? { authorization: `Bearer ${accessToken}` } : undefined),
    };
  };
};
